module.exports = __webpack_public_path__ + "static/campaign_image-6201af34d6bb8b2f90f119460ffa4d83.jpg";